import Vue from "vue";
import Vuex from "vuex";
import { GetScreenSettings } from "@/api/electric.js";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
	settingList: []
  },
  mutations: {
	setsSettingList(state,data) {
		state.settingList = data;
	}
  },
  actions: {
	getScreenSettings({ commit }, project) {
      return new Promise((resolve, reject) => {
        GetScreenSettings()
          .then((response) => {
			commit("setsSettingList", response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {
    
  }
});
export default store;
